import React from "react";
import { Link } from "react-router-dom";
import i18n from "i18next";
import { ArrowLeft, X } from "lucide-react";

export default function BillingCancel() {
    return (
        <div className="min-h-screen grid place-items-center px-6">
            <div className="max-w-md w-full text-center rounded-2xl border border-white/8 bg-[var(--jr-surface)] p-10 jr-fadein">
                <X className="text-[var(--jr-text-2)] mx-auto" size={40}/>
                <h1 className="font-display text-2xl tracking-tight mt-6">{i18n.t("billing.cancelled")}</h1>
                <p className="text-[var(--jr-text-2)] mt-2">{i18n.t("billing.no_credits")}</p>
                <Link to="/app/credits" data-testid="back-credits" className="mt-8 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[var(--jr-brand)] text-white font-medium hover:bg-[var(--jr-brand-2)]">
                    <ArrowLeft size={16}/> {i18n.t("billing.back_credits")}
                </Link>
            </div>
        </div>
    );
}
